<template>
    <div class="formItem" :class="getClass()">
        <label class="formLabel" v-html="label" @click="$emit('click')"></label>
        <div class="formItem__wrap">
            <select
                class="formSelect"
                :value="value"
                v-on="{ ...$listeners, input: ($event) => $emit('input', $event.target.value) }"
                v-bind="$attrs"
            >
                <option v-for="(key, val) in options" :key="val" :value="val">{{ key }}</option>
            </select>
            <div class="formItem__icon"></div>
        </div>
        <small class="formFeedback" v-if="feedback && (isOk || isError)">{{ feedback }}</small>
        <small class="formHelp" v-if="help">{{ help }}</small>
    </div>
</template>

<script>
    export default {
        name: 'ui-FormSelect',
        props: {
            label: String,
            options: {
                default: [],
            },
            value: {
                default: '',
            },
            feedback: String,
            help: String,
            required: {
                type: Boolean,
                default: false,
            },
            isOk: {
                type: Boolean,
                default: false,
            },
            isError: {
                type: Boolean,
                default: false,
            },
            classStyles: String, // clases adicionales a incorporar
        },
        methods: {
            getClass: function() {
                var classStyles = '';

                if (this.required) classStyles = `${classStyles} formItem--required`;
                if (this.isOk) classStyles = `${classStyles} formItem--isOk`;
                if (this.isError) classStyles = `${classStyles} formItem--isError`;
                if (this.type == 'password') classStyles = `${classStyles} formItem--password`;
                if (this.classStyles != undefined) classStyles = `${classStyles}` + ' ' + this.classStyles;

                return classStyles;
            },
        },
    };
</script>
